module.exports = __webpack_public_path__ + "img/background@2x.9cf36e4d.png";